import { BaseComponent2 } from '../../_common/client/base-component2';
import { push as showSnackbar } from '@otto-ec/otto-components/snackbar/v1';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class CustomerReviewSummaryComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr-summary';

    public async init(): Promise<void> {
        this.performViewTracking();
        this.registerReviewLinkTracking();
        this.initializeFeedback();
    }

    private performViewTracking(): void {
        trackView({
            product_ReviewSummary: ['True'],
        });
    }

    private registerReviewLinkTracking(): void {
        this.getChildElements<HTMLElement>('.js_pdp_cr-summary__reviews-link').forEach(reviewLink => {
            reviewLink.addEventListener('click', () => {
                trackEvent({ product_ReviewSummary: ['ShowSingleReviews'] });
            });
        });
    }

    private initializeFeedback(): void {
        this.getChildElements<HTMLOcButtonV1Element>('.js_pdp_cr-summary__feedback-button').forEach(buttonElement => {
            buttonElement.addEventListener('click', () => {
                const trackingValue = buttonElement.dataset.trackingValue;
                if (trackingValue) {
                    trackEvent({ product_ReviewSummary: [trackingValue] });
                }
                this.hideFeedback();
                showSnackbar('Vielen Dank für Dein Feedback!');
            });
        });
    }

    private hideFeedback(): void {
        this.getChildElement('.js_pdp_cr-summary__feedback')?.classList.add('pdp_cr-summary__feedback--hidden');
    }
}
